"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAgreeDialog = exports.TermsAgreeDialogDefaultProps = exports.VERIFY_USER_MUTATION = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_title_1 = require("./dialog-title");
var person_photo_1 = require("../entities/person-photo");
var use_lang_1 = require("../../hooks/use-lang");
var use_app_routes_1 = require("../../hooks/use-app-routes");
var use_active_user_1 = require("../../hooks/use-active-user");
var sprintf_js_1 = require("sprintf-js");
var html_1 = require("./html");
var dialog_1 = require("./dialog");
var checkbox_1 = require("./checkbox");
var icon_button_1 = require("./icon-button");
var terms_content_scroll_view_1 = require("../entities/terms-content-scroll-view");
var client_1 = require("@apollo/client");
var loader_1 = require("./loader");
var router_1 = require("@reach/router");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
// -------- Queries -------->
exports.VERIFY_USER_MUTATION = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation VeriifyUser($id: String!) {\n    verifyUser(id: $id)\n  }\n"], ["\n  mutation VeriifyUser($id: String!) {\n    verifyUser(id: $id)\n  }\n"])));
exports.TermsAgreeDialogDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n    font-size: ", ";\n    width: 90%;\n    max-width: 840px;\n  "], ["\n    box-shadow: 0px 2px 5px -3px rgba(0, 0, 0, 0.6); \n    font-size: ", ";\n    width: 90%;\n    max-width: 840px;\n  "])), theme_1.theme.FONT_SIZE(15))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-align: left;\n    align-self: stretch;\n  "], ["\n    text-align: left;\n    align-self: stretch;\n  "])))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5), theme_1.theme.UNIT(1))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(5))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    line-height: 1.75em;\n    color: ", ";\n  "], ["\n    margin: 0;\n    line-height: 1.75em;\n    color: ", ";\n  "])), theme_1.theme.COLOR('text'))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(6), theme_1.theme.UNIT(5), theme_1.theme.UNIT(6.2))
});
var AgreeCheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var AgreeCheckboxLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: inline-block;\n    color: ", ";\n    padding-left: ", ";\n    text-transform: uppercase;\n    font-size: ", "em;\n  "], ["\n    display: inline-block;\n    color: ", ";\n    padding-left: ", ";\n    text-transform: uppercase;\n    font-size: ", "em;\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(1), 14 / 15)
});
var ContinueButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TermsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    height: 700px;\n    max-height: 44vh;\n    border-top: 1px solid ", ";\n  "], ["\n    height: 700px;\n    max-height: 44vh;\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-mid'))
});
var UpdatingLoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    height: 700px;\n    max-height: 44vh;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid ", ";\n  "], ["\n    height: 700px;\n    max-height: 44vh;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: (0, styled_components_1.default)(dialog_title_1.DialogTitle)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), UpdatingLoaderStyles),
  Body: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Intro: styled_components_1.default.header(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Content: styled_components_1.default.p(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Terms: (0, styled_components_1.default)(terms_content_scroll_view_1.TermsContentScrollView)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TermsStyles),
  Controls: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  AgreeCheckbox: (0, styled_components_1.default)(checkbox_1.Checkbox)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AgreeCheckboxStyles),
  AgreeCheckboxLabel: styled_components_1.default.span(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), AgreeCheckboxLabelStyles),
  ContinueButton: (0, styled_components_1.default)(icon_button_1.NextIconButton)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContinueButtonStyles)
};
var TermsAgreeDialog = function (props) {
  var className = props.className;
  var profile = (0, use_active_user_1.useActiveUser)();
  var mustChangePassword = profile.mustChangePassword;
  var t = (0, use_lang_1.useLang)();
  var givenName = profile.givenName;
  var _a = __read((0, client_1.useMutation)(exports.VERIFY_USER_MUTATION), 2),
    verifyUser = _a[0],
    error = _a[1].error;
  var apolloClient = (0, client_1.useApolloClient)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  var _b = __read((0, react_1.useState)(false), 2),
    agreeChecked = _b[0],
    setAgreeChecked = _b[1];
  var _c = __read((0, react_1.useState)(false), 2),
    updating = _c[0],
    setUpdating = _c[1];
  var onAgreeChange = function (value) {
    setAgreeChecked(value);
  };
  var onContinueClick = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var input, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            input = {
              agreesToTerms: true
            };
            setUpdating(true);
            return [4 /*yield*/, verifyUser({
              variables: {
                id: profile.id,
                input: input
              }
            })];
          case 1:
            result = _a.sent();
            if (!!(error && error.graphQLErrors && error.graphQLErrors.length)) return [3 /*break*/, 3];
            return [4 /*yield*/, apolloClient.resetStore()];
          case 2:
            _a.sent();
            if (mustChangePassword) {
              (0, router_1.navigate)(routes.setupChangePassword);
            } else {
              window.location.href = routes.profile;
            }
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  var person = {
    id: profile.id,
    name: profile.name,
    slug: profile.slug,
    photo: profile.picture && {
      id: profile.picture,
      url: profile.picture
    }
  };
  // TODO - move this to an external template?
  var introTemplate = t("\n    <b>Welcome %s</b>, and thanks for joining us.\n    <br />\n    Please review our Terms of Use and Privacy Policy to continue.\n  ");
  var introText = (0, sprintf_js_1.sprintf)(introTemplate, givenName);
  var checkboxLabel = t('I agree to the Terms of Use and Privacy Policy');
  var continueLabel = t('Continue');
  var continueIsDisabled = updating || !agreeChecked;
  return react_1.default.createElement(My.Container, {
    title: t('Welcome'),
    padBody: false,
    controls: react_1.default.createElement(My.Controls, null, react_1.default.createElement(My.AgreeCheckbox, {
      size: 16,
      borderWidth: 1,
      checked: agreeChecked,
      onChange: onAgreeChange
    }, react_1.default.createElement(My.AgreeCheckboxLabel, null, checkboxLabel)), react_1.default.createElement(My.ContinueButton, {
      disabled: continueIsDisabled,
      onClick: onContinueClick
    }, continueLabel)),
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Intro, null, react_1.default.createElement(My.Photo, {
    size: 64,
    entity: person
  }), react_1.default.createElement(My.Content, null, react_1.default.createElement(html_1.HTML, {
    text: introText
  }))), updating ? react_1.default.createElement(My.Loader, {
    spinnerSize: 18
  }, t('Please wait...')) : react_1.default.createElement(My.Terms, null)));
};
exports.TermsAgreeDialog = TermsAgreeDialog;
exports.TermsAgreeDialog.defaultProps = exports.TermsAgreeDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;